// --- 招接待 --- //

export default [
  {
    name: 'reserveCheck',
    path: '/receptionSupervise/reserveCheck',
    meta: { title: '招接待' },
    component: require('business/receptionSupervise/reserveCheck/list.vue').default
  }
]
